import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export const ATTESTATION_MODEL_URL = 'attestation-model';

@Injectable({
  providedIn: 'root'
})
export class AttestationModelService {
  constructor(private http: HttpClient) {}

  getListByPrescriberId(prescriberId: any): any {
    return this.http
      .get(`${environment.apiRoot}${ATTESTATION_MODEL_URL}?prescriberId=${prescriberId}`)
      .toPromise();
  }

  getById(modelId: number) {
    return this.http.get(`${environment.apiRoot}${ATTESTATION_MODEL_URL}/${modelId}`).toPromise();
  }

  create(attestationModel: any) {
    return this.http
      .post(`${environment.apiRoot}${ATTESTATION_MODEL_URL}`, attestationModel)
      .toPromise();
  }

  update(attestationModel: any, modelId: number) {
    return this.http
      .put(`${environment.apiRoot}${ATTESTATION_MODEL_URL}/${modelId}`, attestationModel)
      .toPromise();
  }

  deleteById(modelId: string) {
    return this.http.delete(`${environment.apiRoot}${ATTESTATION_MODEL_URL}/${modelId}`).toPromise();
  }
}
